export default "__VITE_ASSET__00ea7fc8__"